import { getSession, removeSession, setSession } from '@/utils/sessionStorage'

export const WAREHOUSE_AUTH_SWITCH_NOTICE_KEY = 'nurm_warehouse_auth_switch_notice_v1'

export type PendingWarehouseAuthSwitchNotice = {
  warehouseId: string
  warehouseName: string
  createdAt: number
}

export const setPendingWarehouseAuthSwitchNotice = (
  notice: PendingWarehouseAuthSwitchNotice
): void => {
  setSession(WAREHOUSE_AUTH_SWITCH_NOTICE_KEY, notice)
}

export const getPendingWarehouseAuthSwitchNotice =
  (): PendingWarehouseAuthSwitchNotice | null =>
    getSession<PendingWarehouseAuthSwitchNotice>(WAREHOUSE_AUTH_SWITCH_NOTICE_KEY)

export const clearPendingWarehouseAuthSwitchNotice = (): void => {
  removeSession(WAREHOUSE_AUTH_SWITCH_NOTICE_KEY)
}
